'use strict';

frontendApp.directive('equal', ['$parse', function($parse) {

    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function(viewValue) {

                if (viewValue === scope.$eval(attrs.equal)) {
                    ctrl.$setValidity('equal', true);
                    return viewValue;
                } else {
                    ctrl.$setValidity('equal', false);
                    return undefined;
                }
            });
        }
    };
    
}]);
